import React, { useCallback, useEffect, useState } from "react";
import { Table } from "reactstrap";
import { useParams } from "react-router-dom";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { useDispatch } from "react-redux";
import Loading from "../../components/Loading";
import { callRemote, POST } from "../../service/RemoteService";
import { determineIfTokenError } from "../../store/AuthThunks";

// Read-only photographer profile for photography managers, reached by a
// deep link sent over SMS — there is deliberately no nav link to it.
// The backend gates POST /photographers/get to the Photography Manager role.
export const PhotographerProfile = () => {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const { authId } = useParams();

  const [photographer, setPhotographer] = useState(null);
  const [failed, setFailed] = useState(false);

  const getPhotographer = useCallback(() => {
    // authIds are Auth0 subjects like "auth0|abc123"; the pipe arrives
    // percent-encoded and react-router v5 leaves params encoded.
    callRemote(getAccessTokenSilently, POST, "/photographers/get", { id: decodeURIComponent(authId) })
      .then(resp => {
        setPhotographer(resp);
      }).catch(e => {
        setFailed(true);
        dispatch(determineIfTokenError(e));
      });
  }, [authId, dispatch, getAccessTokenSilently]);

  useEffect(() => {
    getPhotographer();
  }, [getPhotographer]);

  const formatPhoneNumber = (phoneNumberString) => {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return phoneNumberString;
  }

  if (failed) {
    return <p>Could not load this photographer's profile.</p>;
  }

  if (photographer == null) {
    return <Loading />;
  }

  return (
    <div>
      <h2>{photographer.name}</h2>
      <Table striped bordered hover responsive>
        <tbody>
          <tr>
            <th scope="row">Email</th>
            <td>{photographer.email}</td>
          </tr>
          <tr>
            <th scope="row">Phone</th>
            <td>{formatPhoneNumber(photographer.phoneNumber)}</td>
          </tr>
          <tr>
            <th scope="row">Street</th>
            <td>{photographer.street}</td>
          </tr>
          <tr>
            <th scope="row">City</th>
            <td>{photographer.city}</td>
          </tr>
          <tr>
            <th scope="row">State</th>
            <td>{photographer.state}</td>
          </tr>
          <tr>
            <th scope="row">Zip</th>
            <td>{photographer.zip}</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default withAuthenticationRequired(PhotographerProfile, {
  onRedirecting: () => <Loading />,
});
